<template>
  <div>
    <Loader :loading="loading" />
    <v-layout v-if="products.length" justify-center wrap>
      <v-flex md12>
        <v-data-table :headers="headers" :items="products" hide-actions>
          <template slot="headerCell" slot-scope="{ header }">
            <span
              class="subheading font-weight-light text-success text--darken-3"
              v-text="header.text"
            />
          </template>

          <template slot="items" slot-scope="{ item }">
            <td class="text-xs-left">
              <img
                v-if="item.images && item.images.length"
                width="90"
                :src="item.images[0].image_medium"
                alt
              />
            </td>
            <td class="text-xs-left">
              <b>{{ item.iteration }}</b>
            </td>
            <td class="text-xs-left">
              <b>{{ item.percent }}</b>
            </td>
            <td class="text-xs-left">
              <b>{{ item.vendor_code }}</b>
            </td>
            <td class="text-xs-left">
              <b>{{ item.options_count }}</b>
            </td>
            <td class="text-xs-left">
              <b>{{ item.title }}</b>
            </td>
            <td class="text-xs-left">
              <v-icon class="mr-3 text-info" @click="infoItem(item)"
                >mdi-information-outline</v-icon
              >
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="productModal"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-btn
          class="close default v-btn--simple"
          @click="productModal = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text>
          <div class="body-2 mt-5">
            <tournament-serials
              v-if="product_id && productModal"
              :TournamentID="Tournament_id"
              :dealerID="dealer_id"
              :productID="product_id"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loader from "../../helper/Loader";
import TournamentSerials from "./TournamentSerials";
export default {
  data: () => ({
    products: [],
    vendor_codes: [],
    participant: {},
    loading: true,
    product_id: null,
    productModal: false,
    findLoading: false,
    headers: [
      {
        sortable: false,
        text: "Изображение",
        value: "id",
      },
      {
        sortable: false,
        text: "Количество итераций",
        value: "id",
      },
      {
        sortable: false,
        text: "Доп. бонус",
        value: "id",
      },
      {
        sortable: false,
        text: "Артикул",
        value: "dealer.name",
      },
      {
        sortable: false,
        text: "Количество активаций",
        value: "dealer.options_count",
      },
      {
        sortable: false,
        text: "Наименование",
        value: "dealer.name",
      },
    ],
  }),
  components: { Loader, TournamentSerials },
  methods: {
    getProducts() {
      axios
        .get("admin/tournaments/products/" + this.Tournament_id, {
          params: {
            dealer_id: this.dealer_id,
          },
        })
        .then((response) => {
          this.products = response.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 400);
        });
    },
    infoItem(item) {
      if (item && item.id) {
        this.product_id = item.id;
        this.productModal = true;
      }
    },
  },
  computed: {
    Tournament_id: {
      get() {
        return this.TournamentID;
      },
      set(val) {},
    },
    dealer_id: {
      get() {
        return this.dealerID;
      },
      set(val) {},
    },
  },
  mounted() {
    this.getProducts();
  },
  props: ["TournamentID", "dealerID"],
  // watch:{
  //   dealer_id(val){
  //     if (val){
  //       this.loading = true;
  //        this.getProducts();
  //     }
  //   }
  // }
};
</script>
